import { LPA_URLS, LpaFormPages } from "app/constants/lpaAcp";

export const LpaBaseUrl = "/find-a-service/lpa";

export const LpaUrl = {
	landingPage: LpaBaseUrl,
	allowAccess: LPA_URLS.LPA_ACP_LANDING_URL + "/allow-access",
	personalDetails: LPA_URLS.LPA_ACP_FORM_URL + "/" + LpaFormPages.LPA_FORM_1,
};
